import { Component } from '@angular/core';
import { RssfeedsService } from '../rssfeeds.service';
import { NewsItem } from 'src/app/models/master-data.model';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-newsand-trends',
  templateUrl: './newsand-trends.component.html',
  styleUrls: ['./newsand-trends.component.scss']
})
export class NewsandTrendsComponent {
  newsCategories = [
    { title: 'Top Stories', key: 'topstories', data: [] as NewsItem[], visibleNewsCount: 15 , imageLink:'./../../assets/images/icons/growth.svg'},
    { title: 'Hospital News', key: 'hospitals', data: [] as NewsItem[], visibleNewsCount: 15 , imageLink: './../../assets/images/icons/hospital-sign.svg'},
    { title: 'Pharmaceutical News', key: 'pharma', data: [] as NewsItem[], visibleNewsCount: 15 , imageLink: './../../assets/images/icons/medicine.svg'},
  ];

  constructor(private rssfeedsService: RssfeedsService , private spinnerService: SpinnerService) {}

  ngOnInit(): void {
    this.loadAllNewsCategories();
    const topOfPage = document.querySelector('app-root');
    if (topOfPage) {
        topOfPage.scrollIntoView({ behavior: 'smooth' });
      } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }
 
  }

  async loadAllNewsCategories(): Promise<void> {
    this.spinnerService.showSpinner();
    try {
      for (const category of this.newsCategories) {
        category.data = await this.rssfeedsService.fetchAndParseRssFeed(category.key) as NewsItem[];
      }
    } catch (error) {
      Swal.fire('Oops...','Error loading RSS feed data')
     
    }
    this.spinnerService.hideSpinner();
  }

  loadMoreNews(category: any) {
    category.visibleNewsCount += 15; // Load 15 more items on each click
  }

  redirectToNews(newsLink: any) {
    window.open(newsLink,'_blank');
  }
}
